import { AgendaComponent } from './component/agenda/agenda.component';
import { BrowserModule } from '@angular/platform-browser';
import { NgModule } from '@angular/core';
import { HttpClientModule, HTTP_INTERCEPTORS } from '@angular/common/http';
import { AppRoutingModule } from './app-routing.module';
import { FormsModule } from '@angular/forms';
import { AppComponent } from './app.component';
import { DashboardComponent } from './component/dashboard/dashboard.component';
import { NoteComponent } from './component/dashboard/note/note.component';
import { ReactiveFormsModule } from '@angular/forms';
import { LoginComponent } from './component/login/login.component';
import { authInterceptorProviders } from './services/auth.interceptor';
import { OpenspaceComponent } from './component/openspace/openspace.component';
import { AddComponent } from './component/openspace/add/add.component';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { MatInputModule } from '@angular/material/input';
import { MatButtonModule} from '@angular/material/button';
import { MatCardModule} from '@angular/material/card';
import { MatFormFieldModule} from '@angular/material/form-field';
import { MatDialogModule } from '@angular/material/dialog';
import { MatIconModule} from '@angular/material/icon';
import { MatDatepickerModule} from '@angular/material/datepicker';
import { MatNativeDateModule, MAT_DATE_LOCALE} from '@angular/material/core';
import { MatCheckboxModule} from '@angular/material/checkbox';
import { MatSelectModule} from '@angular/material/select';
import { environment } from 'src/environments/environment';
import { Configuration } from 'msal';
import { MSAL_CONFIG, MsalAngularConfiguration, MSAL_CONFIG_ANGULAR, MsalService, MsalModule, MsalInterceptor } from '@azure/msal-angular';
import { MatTableModule } from '@angular/material/table';
import { MatSortModule } from '@angular/material/sort';
import { ToastrModule } from 'ngx-toastr';
import { AddAgendaComponent } from './component/agenda/add-agenda/add-agenda.component';
import { AddSessionComponent } from './component/agenda/add-session/add-session.component';
import { ProposalComponent } from './component/proposal/proposal.component';
import { AddTrackComponent } from './component/agenda/add-track/add-track.component';
import { MatListModule } from '@angular/material/list';
import { MatMenuModule } from '@angular/material/menu';
import { CommentComponent } from './component/comment/comment.component';
import { InfiniteScrollModule } from 'ngx-infinite-scroll';
import { DragDropModule} from '@angular/cdk/drag-drop';
import { OpenSelectorComponent } from './component/open-selector/open-selector.component';
import { NavbarComponent } from './component/navbar/navbar.component';
import { RemainingVotesComponent } from './component/remaining-votes/remaining-votes.component';
import { ConfirmationDialogComponent } from './component/confirmation-dialog/confirmation-dialog.component';
import { UserMenuComponent } from './component/user-menu/user-menu.component';
import { ReportComponent } from './component/report/report.component';
import { ChartsModule } from 'ng2-charts';
import { ReportProposalCategoriesComponent } from './component/report/report-proposal-categories/report-proposal-categories.component';
import { MatGridListModule} from '@angular/material/grid-list';
import { ReportTrackVotersComponent } from './component/report/report-track-voters/report-track-voters.component';
import { ReportTotalProposalsComponent } from './component/report/report-total-proposals/report-total-proposals.component';
import { ReportTotalVotersComponent } from './component/report/report-total-voters/report-total-voters.component';
import { GenAgendaComponent } from './component/agenda/gen-agenda/gen-agenda.component';
import { ReportSurveyComponent } from './component/report-survey/report-survey.component';
import { TrackNotesComponent } from './component/track-notes/track-notes.component';
import { TrackDocumentationComponent } from './component/track-documentation/track-documentation.component';
import { UtilitiesService } from './services/utilities.service';
import {DatePipe} from '@angular/common';
import {MatSnackBarModule} from '@angular/material/snack-bar';
import { NotifierService } from './services/notifier.service';
import { AddUrlComponent } from './component/agenda/add-url/add-url.component';
import { MatTooltipModule } from '@angular/material/tooltip';
import {CountdownModule} from "ngx-countdown";

export const protectedResourceMap: [string, string[]][] = [
  ['https://graph.microsoft.com', ['user.read']]
];

// TODO: remove popup if it works in browsers (chrome firefox ie edge)
// const isIE = window.navigator.userAgent.indexOf('MSIE ') > -1 || window.navigator.userAgent.indexOf('Trident/') > -1;
const isIE = true;

function MSALConfigFactory(): Configuration {
  return {
    auth: {
      clientId: environment.clientId,
      authority: environment.authority,
      validateAuthority: true,
      redirectUri: environment.redirectUrl,
      postLogoutRedirectUri: environment.logoutUrl,
      navigateToLoginRequestUrl: true
    },
    cache: {
      cacheLocation: 'sessionStorage',
      storeAuthStateInCookie: isIE, // set to true for IE 11,
    }
  };
}

function MSALAngularConfigFactory(): MsalAngularConfiguration {
  return {
    popUp: !isIE,
    consentScopes: [
      'user.read',
      'openid',
      'profile',
      'api://openspacetest.oidcompliant/opn.read'
    ],
    unprotectedResources: ['https://www.microsoft.com/en-us/'],
    protectedResourceMap,
    extraQueryParameters: {}
  };
}

@NgModule({
  declarations: [
    AppComponent,
    DashboardComponent,
    NoteComponent,
    LoginComponent,
    OpenspaceComponent,
    AddComponent,
    AgendaComponent,
    AddAgendaComponent,
    AddSessionComponent,
    ProposalComponent,
    AddTrackComponent,
    CommentComponent,
    OpenSelectorComponent,
    NavbarComponent,
    RemainingVotesComponent,
    ConfirmationDialogComponent,
    UserMenuComponent,
    ReportComponent,
    ReportProposalCategoriesComponent,
    ReportTrackVotersComponent,
    ReportTotalProposalsComponent,
    ReportTotalVotersComponent,
    GenAgendaComponent,
    ReportSurveyComponent,
    TrackNotesComponent,
    TrackDocumentationComponent,
     AddUrlComponent
  ],
    imports: [
        BrowserModule,
        AppRoutingModule,
        ReactiveFormsModule,
        FormsModule,
        HttpClientModule,
        BrowserAnimationsModule,
        MatDialogModule,
        MatInputModule,
        MatButtonModule,
        MatCardModule,
        MatFormFieldModule,
        MatGridListModule,
        MatDatepickerModule,
        MatNativeDateModule,
        MatCheckboxModule,
        MatTableModule,
        MatSortModule,
        MatIconModule,
        MatListModule,
        MatMenuModule,
        MatSelectModule,
        InfiniteScrollModule,
        DragDropModule,
        ChartsModule,
        ToastrModule.forRoot({
            timeOut: 5000,
            positionClass: 'toast-top-right',
            preventDuplicates: true
        }), // ToastrModule added
        MsalModule,
        MatSnackBarModule,
        MatTooltipModule,
        CountdownModule
    ],
  providers: [
      DatePipe,
    authInterceptorProviders,
    {
      provide: MSAL_CONFIG,
      useFactory: MSALConfigFactory
    },
    {
      provide: MSAL_CONFIG_ANGULAR,
      useFactory: MSALAngularConfigFactory
    },
    {provide: MAT_DATE_LOCALE, useValue: 'es'},
    MsalService,
  ],
  bootstrap: [AppComponent]
})
export class AppModule { }
